import basketball from './assets/purple/basketball.svg';
import dolar from './assets/purple/dolar.svg';
import language from './assets/purple/language.svg';
import rocket from './assets/purple/rocket.svg';
import time from './assets/purple/time.svg';
import verified from './assets/purple/verified.svg';

export const purpleData = [time, rocket, verified, language, basketball, dolar];
